__turbopack_context__.v({
  "attributesList": "HeaderSectionPrize-module__3O4xHG__attributesList",
  "bundleImage": "HeaderSectionPrize-module__3O4xHG__bundleImage",
  "bundleItem": "HeaderSectionPrize-module__3O4xHG__bundleItem",
  "bundleItemContainer": "HeaderSectionPrize-module__3O4xHG__bundleItemContainer",
  "bundleItemsContainer": "HeaderSectionPrize-module__3O4xHG__bundleItemsContainer",
  "bundleText": "HeaderSectionPrize-module__3O4xHG__bundleText",
  "column1": "HeaderSectionPrize-module__3O4xHG__column1",
  "column2": "HeaderSectionPrize-module__3O4xHG__column2",
  "ctaContainer": "HeaderSectionPrize-module__3O4xHG__ctaContainer",
  "headerArea": "HeaderSectionPrize-module__3O4xHG__headerArea",
  "headerCarousel": "HeaderSectionPrize-module__3O4xHG__headerCarousel",
  "headerContainer": "HeaderSectionPrize-module__3O4xHG__headerContainer",
  "headerImage": "HeaderSectionPrize-module__3O4xHG__headerImage",
  "headerImageCarousel": "HeaderSectionPrize-module__3O4xHG__headerImageCarousel",
  "headerImageContainer": "HeaderSectionPrize-module__3O4xHG__headerImageContainer",
  "headerImageContainerInner": "HeaderSectionPrize-module__3O4xHG__headerImageContainerInner",
  "headerTextContainer": "HeaderSectionPrize-module__3O4xHG__headerTextContainer",
  "headerTextContainerInner": "HeaderSectionPrize-module__3O4xHG__headerTextContainerInner",
  "infoContainer": "HeaderSectionPrize-module__3O4xHG__infoContainer",
  "otherImage": "HeaderSectionPrize-module__3O4xHG__otherImage",
  "otherImagesContainer": "HeaderSectionPrize-module__3O4xHG__otherImagesContainer",
  "otherImagesContainerInner": "HeaderSectionPrize-module__3O4xHG__otherImagesContainerInner",
  "overviewBody": "HeaderSectionPrize-module__3O4xHG__overviewBody",
  "prizeBadgeHolder": "HeaderSectionPrize-module__3O4xHG__prizeBadgeHolder",
  "subheading": "HeaderSectionPrize-module__3O4xHG__subheading",
  "textContainer1": "HeaderSectionPrize-module__3O4xHG__textContainer1",
  "textContainer2": "HeaderSectionPrize-module__3O4xHG__textContainer2",
  "trustPilotMobile": "HeaderSectionPrize-module__3O4xHG__trustPilotMobile",
  "trustpilotDesktop": "HeaderSectionPrize-module__3O4xHG__trustpilotDesktop",
});
